export function calculateRelativeAngle(bearing: number, heading: number): number {
  const normalized = ((bearing - heading + 540) % 360) - 180;
  return Object.is(normalized, -0) ? 0 : normalized;
}
